import { render, staticRenderFns } from "./SheetReadOnly.vue?vue&type=template&id=ab05f5d6"
import script from "./SheetReadOnly.vue?vue&type=script&lang=js"
export * from "./SheetReadOnly.vue?vue&type=script&lang=js"
import style0 from "./SheetReadOnly.vue?vue&type=style&index=0&id=ab05f5d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports